/* ============================================================
   Regles de panier : lot mal forme + cadeau offert
   ============================================================
   Charge APRES mirthly.js. Fichier separe volontairement : mirthly.js fait
   46 Ko minifies, le reecrire pour quelques regles serait une prise de
   risque sans contrepartie. On se greffe sur ses fonctions globales.

   ------------------------------------------------------------
   REGLE 1 — LE SELECTEUR DE QUANTITE CONTOURNE LES LOTS
   ------------------------------------------------------------
   Le tiroir laisse augmenter la quantite de la variante « 1 calendar ».
   Trois exemplaires de la variante simple coutent 119,97 $, alors que la
   variante « 3 calendars » coute 89,88 $ pour EXACTEMENT la meme
   marchandise. Le client paie 30,09 $ de trop, soit 33 % au-dessus du prix
   du lot, et rien ne le lui signale.

     1 calendar x2 = 79,98 $   contre   2 calendars = 59,92 $   (+20,06 $)
     1 calendar x3 = 119,97 $  contre   3 calendars = 89,88 $   (+30,09 $)

   On ne remplace pas la ligne en silence : modifier le panier de quelqu'un
   sans le lui dire est desagreable, meme quand c'est en sa faveur. On
   affiche l'ecart et on propose l'echange en un geste, avec le composant
   .upsell deja prevu par la feuille de style.

   ------------------------------------------------------------
   REGLE 2 — CADEAU OFFERT SUR TOUTE COMMANDE AVEC CALENDRIER
   ------------------------------------------------------------
   L'offre a change : ce n'etait qu'un gift wrap reserve au dernier palier,
   c'est maintenant le Teenie NeeDoh Hot Shots Multipack, offert des le
   PREMIER calendrier. La condition n'est donc plus « le palier 3 est dans
   le panier » mais « au moins un calendrier est dans le panier ».

   Changement important sur la gratuite. L'ancienne version utilisait une
   variante dediee a 0,00 $. C'etait tenable pour un gift wrap discret ;
   ca ne l'est plus pour un cadeau annonce sur toute la page produit : une
   variante a 0,00 $ publiee est achetable seule, et la livraison etant
   offerte, n'importe qui pouvait commander des cadeaux gratuits a volonte.

   La gratuite passe donc par une remise automatique Shopify « Buy X Get Y »,
   verifiee : cadeau seul dans le panier = 7,99 $ factures, cadeau avec un
   calendrier = 0,00 $, deux cadeaux = un seul offert. C'est Shopify qui
   tient l'argent, ce script ne fait que poser la ligne dans le panier.

   L'etat se decide en lisant LE PANIER, pas le palier affiche : un client
   peut ajouter un palier puis changer de selection sans rien retirer.
   ============================================================ */
(function () {
  "use strict";

  /* Variante du produit offert. Le prix affiche barre vient de la ligne
     Shopify elle-meme (original_line_price), pas de cette constante : elle
     ne sert que de repli si la ligne n'est pas encore lue. */
  var GIFT_VARIANT = 58673023582543;   /* Teenie NeeDoh Hot Shots Multipack */
  var GIFT_WAS_CENTS = 799;

  var D = window.MIRTHLY_DATA || null;
  if (!D || !D.variants || !D.variants.length) return;

  var VARS = D.variants;
  var SINGLE = VARS[0];
  /* Tous les identifiants de variante du calendrier : la condition du cadeau
     porte sur n'importe laquelle, plus seulement sur la derniere. */
  var CAL_IDS = VARS.map(function (v) { return String(v.id); });

  var busy = false;
  var lastCart = null;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = D.moneyFormat;
    if (!f) return "$" + v;
    return f
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","));
  }

  function json(url, body) {
    var opt = body
      ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
      : { headers: { Accept: "application/json" } };
    return fetch(url, opt).then(function (r) { return r.json(); });
  }

  function findLine(cart, variantId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(variantId)) return items[i];
    }
    return null;
  }

  function hasCalendar(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (CAL_IDS.indexOf(String(items[i].variant_id)) !== -1) return true;
    }
    return false;
  }

  /* ---------- regle 1 : detection du lot mal forme ---------- */
  function badBundle(cart) {
    if (!SINGLE || !SINGLE.id) return null;

    /* Shopify peut tenir plusieurs lignes pour la MEME variante. On
       additionne donc la quantite sur toutes, sans quoi deux calendriers
       ajoutes separement passent inapercus et le client paie le plein tarif. */
    var lignes = ((cart && cart.items) || []).filter(function (l) {
      return String(l.variant_id) === String(SINGLE.id);
    });
    if (!lignes.length) return null;

    var n = 0, paying = 0;
    lignes.forEach(function (l) { n += l.quantity; paying += l.final_line_price; });
    if (n < 2 || n > VARS.length) return null;      /* au-dela on ne devine pas */

    var target = VARS[n - 1];
    if (!target || !target.id || String(target.id) === String(SINGLE.id)) return null;

    var would = target.price;
    if (!(paying > would)) return null;

    return { lines: lignes, target: target, n: n, save: paying - would, paying: paying, would: would };
  }

  function swap(offer) {
    if (busy) return Promise.resolve();
    busy = true;
    /* On retire toutes les lignes concernees, pas seulement la premiere. */
    var chaine = Promise.resolve();
    offer.lines.forEach(function (l) {
      chaine = chaine.then(function () { return json("/cart/change.js", { id: l.key, quantity: 0 }); });
    });
    return chaine
      .then(function () { return json("/cart/add.js", { items: [{ id: Number(offer.target.id), quantity: 1 }] }); })
      .then(function () { busy = false; return reconcile(); })
      .then(function () { if (typeof window.refreshCart === "function") return window.refreshCart(); })
      .catch(function () { busy = false; });
  }

  /* ---------- regle 2 : le cadeau ---------- */

  /* Offre BUY 1 GET 1 FREE (mirthly-bogo.js) : un cadeau PAR PAIRE.
     La remise Shopify de l offre offre, a chaque utilisation, le calendrier
     gratuit ET un Hot Shots ; elle ne s applique a une paire que si un Hot
     Shots l accompagne. Sans offre active : un seul cadeau, comme avant. */
  function giftQty(cart) {
    var B = window.MirthlyBogo;
    if (!B || typeof B.actif !== "function" || !B.actif()) return 1;
    var n = 0;
    ((cart && cart.items) || []).forEach(function (l) {
      if (String(l.variant_id) === String(B.variantId)) n += l.quantity;
    });
    return Math.max(1, Math.floor(n / 2));
  }

  /* REGLE 1 (version automatique, 2026-10-01)
     Le tiroir n a plus de selecteur de quantite pour les calendriers. Si un
     panier arrive quand meme avec plusieurs « 1 calendar » (ancien panier,
     autre page), on les remplace par les packs, toujours moins chers, a
     nombre de calendriers IDENTIQUE, avec la combinaison la moins chere :
     2 -> pack de 2, 3 -> pack de 3, 4 -> 2 packs de 2, 5 -> 3 + 2, etc.
     Pendant une offre BUY 1 GET 1 (mirthly-bogo.js), deux « 1 calendar »
     sont voulus : on n y touche pas. */
  /* Combinaison la MOINS CHERE de packs pour n calendriers (prix reels des
     variantes) : 4 -> 2 packs de 2 (119,84 $) plutot que 3 + 1 (129,87 $). */
  function cibleLots(n) {
    var p1 = SINGLE.price, v2 = VARS[1], v3 = VARS[2];
    var best = null;
    for (var a = 0; v3 && a * 3 <= n; a++) {
      for (var b = 0; v2 && a * 3 + b * 2 <= n; b++) {
        var c = n - a * 3 - b * 2;
        var prix = a * v3.price + b * v2.price + c * p1;
        if (!best || prix < best.prix) best = { prix: prix, a: a, b: b, c: c };
      }
      if (!v2) {
        var c2 = n - a * 3, prix2 = a * v3.price + c2 * p1;
        if (!best || prix2 < best.prix) best = { prix: prix2, a: a, b: 0, c: c2 };
      }
    }
    if (!v3 && v2) {
      for (var b2 = 0; b2 * 2 <= n; b2++) {
        var c3 = n - b2 * 2, prix3 = b2 * v2.price + c3 * p1;
        if (!best || prix3 < best.prix) best = { prix: prix3, a: 0, b: b2, c: c3 };
      }
    }
    var items = [];
    if (!best) return items;
    if (best.a) items.push({ id: Number(v3.id), quantity: best.a });
    if (best.b) items.push({ id: Number(v2.id), quantity: best.b });
    if (best.c) items.push({ id: Number(SINGLE.id), quantity: best.c });
    return items;
  }

  function aConvertir(cart) {
    var B = window.MirthlyBogo;
    if (B && typeof B.actif === "function" && B.actif()) return null;
    if (!SINGLE || !SINGLE.id) return null;
    var lignes = ((cart && cart.items) || []).filter(function (l) {
      return String(l.variant_id) === String(SINGLE.id);
    });
    var n = lignes.reduce(function (s, l) { return s + l.quantity; }, 0);
    if (n < 2) return null;
    var items = cibleLots(n);
    var prixCible = items.reduce(function (s, it) {
      var v = VARS.filter(function (x) { return String(x.id) === String(it.id); })[0];
      return s + (v ? v.price * it.quantity : 0);
    }, 0);
    var paye = lignes.reduce(function (s, l) { return s + l.final_line_price; }, 0);
    /* Jamais de conversion qui couterait plus cher au client. */
    if (!(prixCible < paye)) return null;
    return { lignes: lignes, items: items };
  }

  function convertir(plan) {
    var chaine = Promise.resolve();
    plan.lignes.forEach(function (l) {
      chaine = chaine.then(function () { return json("/cart/change.js", { id: l.key, quantity: 0 }); });
    });
    return chaine.then(function () { return json("/cart/add.js", { items: plan.items }); });
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return json("/cart.js")
      .then(function (cart) {
        lastCart = cart;
        var plan = aConvertir(cart);
        if (plan) {
          return convertir(plan).then(function () { return json("/cart.js"); }).then(function (c2) {
            lastCart = c2; cart = c2; return c2;
          }).then(function (c2) { return { converti: true, cart: c2 }; });
        }
        return { converti: false, cart: cart };
      })
      .then(function (etat) {
        var cart = etat.cart;
        var qualifies = hasCalendar(cart);
        var gift = findLine(cart, GIFT_VARIANT);

        /* La propriete privee sert au tiroir a reconnaitre la ligne meme si
           l'identifiant de variante change un jour. Le souligne la rend
           invisible pour le client, au panier comme sur la commande. */
        var voulu = giftQty(cart);
        if (etat.converti && !(qualifies && !gift) && !(!qualifies && gift)) return true;
        if (qualifies && !gift) {
          return json("/cart/add.js", {
            items: [{ id: GIFT_VARIANT, quantity: voulu, properties: { _mirthly_free_gift: "true" } }]
          });
        }
        if (!qualifies && gift) return json("/cart/change.js", { id: gift.key, quantity: 0 });
        if (qualifies && gift && gift.quantity !== voulu) return json("/cart/change.js", { id: gift.key, quantity: voulu });
        return null;
      })
      .then(function (changed) {
        busy = false;
        if (changed && typeof window.refreshCart === "function") return window.refreshCart();
      })
      .catch(function () { busy = false; });
  }

  /* ---------- affichage : le tiroir ---------- */
  function paintOffer(cart) {
    var body = document.getElementById("dwBody");
    if (!body) return;

    var old = body.querySelector("[data-bundle-swap]");
    if (old) old.parentNode.removeChild(old);

    var offer = badBundle(cart);
    if (!offer) return;

    var box = document.createElement("div");
    box.className = "upsell";
    box.setAttribute("data-bundle-swap", "1");
    box.innerHTML =
      "<div><div class=\"u-t\">Switch to the " + offer.n + "-calendar set</div>" +
      "<div class=\"u-d\">Same " + offer.n + " calendars — " + money(offer.would) +
      " instead of " + money(offer.paying) + ".</div></div>" +
      '<button type="button">Save ' + money(offer.save) + "</button>";

    box.querySelector("button").addEventListener("click", function () {
      var b = this;
      b.disabled = true;
      b.textContent = "Switching…";
      swap(offer);
    });

    body.insertBefore(box, body.firstChild);
  }

  /* L habillage des lignes appartient a mirthly-cart-drawer.js. Ici on se
     contente de relire le panier pour alimenter la banniere d echange, qui
     porte une action et reste donc la responsabilite de ce fichier. */
  function decorateCart() {
    if (!document.getElementById("dwBody")) return;
    json("/cart.js").then(function (cart) {
      lastCart = cart;
      /* La banniere « Switch to the N-calendar set » n a plus lieu d etre :
         la conversion se fait toute seule (regle 1). On retire une eventuelle
         banniere restee d un rendu precedent. */
      var old = document.querySelector("[data-bundle-swap]");
      if (old) old.parentNode.removeChild(old);
    }).catch(function () {});
  }

  /* renderCart est une declaration de premier niveau : elle vit sur l'objet
     global et les appels par nom dans mirthly.js passent par lui. La
     remplacer suffit a decorer a chaque rendu. */
  if (typeof window.renderCart === "function") {
    var origRenderCart = window.renderCart;
    window.renderCart = function () {
      var out = origRenderCart.apply(this, arguments);
      try { decorateCart(); } catch (e) {}
      /* Filet de securite : l'enveloppe de fetch plus bas peut etre court-
         circuitee si un autre script remplace window.fetch apres nous. Ici on
         repasse a chaque rendu du panier. reconcile() ne declenche un rendu
         que s'il a reellement change quelque chose, donc pas de boucle. */
      try { reconcile(); } catch (e) {}
      return out;
    };
  }

  /* Les fonctions d'ecriture de mirthly.js sont locales a son script : on ne
     peut pas s'y accrocher. On ecoute donc les appels reseau qui modifient le
     panier. Le garde `busy` empeche nos propres appels de se rappeler. */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    var url = typeof input === "string" ? input : (input && input.url) || "";
    if (!busy && /\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(reconcile, 0); }).catch(function () {});
    }
    return p;
  };

  /* Source unique de l identifiant du produit offert : le tiroir le lit ici
     au lieu de le repeter. Changer de cadeau ne demande donc qu une seule
     modification, dans ce fichier. */
  window.MirthlyGift = { variantId: GIFT_VARIANT };
  window.ensureMirthlyFreeGift = reconcile;

  reconcile();
})();
